import {  put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../components/common/apiConfig";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from "../../../components/method/handleNotificationAlert";


export const actionTypes = {
    SelectOnlineExam: "SelectOnlineExam [Action]",
    SelectOnlineExamLoading: "SelectOnlineExamLoading [Action]",
    SelectOnlineExamAsync: "SelectOnlineExamAsync [Action]",
};
const inistiaState = {
    data: [],
    total:0,
    loading: false
};

export const reducerSelecOnlineExamt = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.SelectOnlineExam:
            return {
                ...state,
                data: payload.results,
                total: payload.total
                  ? payload.total > 10000
                    ? 10000
                    : payload.total
                  : 0
            };
        case actionTypes.SelectOnlineExamLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.SelectOnlineExamLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "questionnaire",
        method_type: "select_online_exam",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.SelectOnlineExam, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.SelectOnlineExamLoading, payload: false })

    }
}

export function* workerSelectOnlineExamt() {
    yield takeLatest(actionTypes.SelectOnlineExamAsync, handleWorker);
}
